const styles = theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    maxWidth: '1200px',
    width: '100%',
  },
  collection: {
    display: 'flex',
    justifyContent: 'center',
    marginRight: '20px',
  },
  collectionContent: {
    maxWidth: '1200px',
    width: '100%',
  },
})

export default styles
